import React, { useContext } from "react";

import CheckCircleRoundedIcon from "@material-ui/icons/CheckCircleRounded";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import BubbleChartRoundedIcon from "@material-ui/icons/BubbleChartRounded";
import ForumRoundedIcon from "@material-ui/icons/ForumRounded";

import { AuthContext } from "../../../context/Auth/AuthContext";

import {
  KoraxOnboardingShell,
  KoraxOnboardingContent,
  KoraxOnboardingFooter
} from "../../../components/KoraxUI/Onboarding";

const getGreeting = () => {
  const hour = new Date().getHours();

  if (hour >= 5 && hour < 12) {
    return "Bom dia";
  }

  if (hour >= 12 && hour < 18) {
    return "Boa tarde";
  }

  return "Boa noite";
};

const getFirstName = name => {
  if (!name || typeof name !== "string") {
    return "";
  }

  return name.trim().split(/\s+/)[0];
};

export default function WelcomeStep({ onContinue }) {
  const { user } = useContext(AuthContext);

  const firstName = getFirstName(user?.name);
  const greeting = getGreeting();

  const benefits = [
    {
      icon: <CheckCircleRoundedIcon style={{ fontSize: 21 }} />,
      title: "Empresa configurada",
      description: "Vamos organizar as informações principais da sua operação."
    },
    {
      icon: <WhatsAppIcon style={{ fontSize: 21 }} />,
      title: "WhatsApp conectado",
      description: "Seu principal canal de atendimento ficará pronto para operar."
    },
    {
      icon: <BubbleChartRoundedIcon style={{ fontSize: 21 }} />,
      title: "IA treinada",
      description: "Sua inteligência artificial aprenderá como atender e vender."
    },
    {
      icon: <ForumRoundedIcon style={{ fontSize: 21 }} />,
      title: "Primeira conversa",
      description: "No final, você poderá conversar com a IA que acabou de criar."
    }
  ];

  return (
    <KoraxOnboardingShell step={1} totalSteps={7}>
      <KoraxOnboardingContent>
        <div
          style={{
            width: "100%",
            maxWidth: 980,
            margin: "0 auto"
          }}
        >
          <div
            style={{
              position: "relative",
              overflow: "hidden",
              padding: "42px 42px 38px",
              borderRadius: 26,
              color: "#FFFFFF",
              background:
                "linear-gradient(135deg, #071B3D 0%, #0D3B87 52%, #155EEF 100%)",
              boxShadow: "0 24px 70px rgba(15, 53, 117, .24)"
            }}
          >
            <div
              style={{
                position: "absolute",
                width: 300,
                height: 300,
                top: -150,
                right: -70,
                borderRadius: "50%",
                background: "rgba(255,255,255,.08)"
              }}
            />

            <div
              style={{
                position: "absolute",
                width: 190,
                height: 190,
                right: 130,
                bottom: -130,
                borderRadius: "50%",
                background: "rgba(255,255,255,.05)"
              }}
            />

            <div
              style={{
                position: "relative",
                zIndex: 1,
                maxWidth: 690
              }}
            >
              <div
                style={{
                  marginBottom: 16,
                  fontSize: 14,
                  fontWeight: 800,
                  color: "rgba(255,255,255,.78)"
                }}
              >
                {greeting}
                {firstName ? `, ${firstName}` : ""} 👋
              </div>

              <h1
                style={{
                  margin: 0,
                  maxWidth: 680,
                  fontSize: "clamp(30px, 4vw, 48px)",
                  fontWeight: 900,
                  lineHeight: 1.08,
                  letterSpacing: "-.035em"
                }}
              >
                Bem-vindo à Korax.
              </h1>

              <p
                style={{
                  maxWidth: 650,
                  margin: "18px 0 0",
                  color: "rgba(255,255,255,.84)",
                  fontSize: 15,
                  lineHeight: 1.7
                }}
              >
                A partir de agora vamos configurar o seu ambiente, conectar seu
                WhatsApp e criar uma inteligência artificial preparada para
                atender seus clientes de forma humanizada.
              </p>
            </div>
          </div>

          <div
            style={{
              marginTop: 22,
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(205px, 1fr))",
              gap: 14
            }}
          >
            {benefits.map(item => (
              <div
                key={item.title}
                style={{
                  padding: 18,
                  borderRadius: 16,
                  border: "1px solid rgba(148,163,184,.22)",
                  background: "rgba(21,94,239,.035)"
                }}
              >
                <div
                  style={{
                    width: 42,
                    height: 42,
                    marginBottom: 14,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: 13,
                    color: "#155EEF",
                    background: "rgba(21,94,239,.10)"
                  }}
                >
                  {item.icon}
                </div>

                <div
                  style={{
                    marginBottom: 7,
                    fontSize: 14,
                    fontWeight: 800,
                    lineHeight: 1.35
                  }}
                >
                  {item.title}
                </div>

                <div
                  style={{
                    color: "#667085",
                    fontSize: 11.5,
                    lineHeight: 1.55
                  }}
                >
                  {item.description}
                </div>
              </div>
            ))}
          </div>
        </div>
      </KoraxOnboardingContent>

      <KoraxOnboardingFooter
        hideBack
        onNext={onContinue}
        nextLabel="Começar configuração"
      />
    </KoraxOnboardingShell>
  );
}
